import { createActions } from 'redux-actions';

import types from 'state/analytics/actionTypes';

const { analytics } = createActions({
  [types.sendEvent$]: ({ eventName, eventData }) => ({ eventName, eventData }),
  [types.sendUnIdentifiedEvent$]: ({ eventName, eventData, country }) => ({
    eventName,
    eventData,
    country,
  }),
});

export default analytics;
